"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withdrawSigned = exports.newWithdrawItem = exports.getWithdrawItem = void 0;
const axios_1 = __importDefault(require("axios"));
let baseURL = process.env.REACT_APP_FOUNDRY_ALGORAND_URL;
const customAxios = axios_1.default.create({ baseURL });
function getWithdrawItem(id) {
    return customAxios.get(`/withdraw/${id}`);
}
exports.getWithdrawItem = getWithdrawItem;
function newWithdrawItem(id, body) {
    return customAxios.patch(`/newWithdrawItem/${id}`, body);
}
exports.newWithdrawItem = newWithdrawItem;
function withdrawSigned(id) {
    return customAxios.get(`/withdraw/${id}`);
}
exports.withdrawSigned = withdrawSigned;
//# sourceMappingURL=WalletWithdrawalClient.js.map